( function () {
	const blocks = document.querySelectorAll( '.wp-block-milestonevideo-theme-kontakt' );
	if ( ! blocks.length ) return;

	const reduceMotion = window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches;

	blocks.forEach( ( block ) => {
		const targets = block.querySelectorAll( '.reveal' );
		if ( ! targets.length ) return;

		if ( reduceMotion || ! ( 'IntersectionObserver' in window ) ) {
			targets.forEach( ( el ) => el.classList.add( 'in' ) );
			return;
		}

		// Próg jak w exporcie: element wjeżdża, gdy jego góra przekroczy ~90% viewportu.
		const observer = new IntersectionObserver(
			( entries ) => {
				entries.forEach( ( entry ) => {
					if ( entry.isIntersecting ) {
						entry.target.classList.add( 'in' );
						observer.unobserve( entry.target );
					}
				} );
			},
			{ root: null, rootMargin: '0px 0px -10% 0px', threshold: 0 }
		);

		targets.forEach( ( el ) => observer.observe( el ) );
	} );
} )();
